import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GlobalSettingsService {
  public API_SERVER_PORT: string;
  public API_SOCKET_PORT: string;
  public API_SOCKET_CRON_PORT: string;
  public API_SOCKET_PATH: string = '/socket.io1/';
  public API_CRON_SOCKET_PATH: string = '/socket.io2/';
  public CARE_API_URL: string;
  public API_SOCKET_SPECIAL_CHAT_PORT: string = '3978';
  public chartColors: Array<any> = [
    { backgroundColor: '#3c8dbc' },
    { backgroundColor: '#f39c12' },
    { backgroundColor: '#00a65a' }
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Use port 4000 when running on localhost. Do not use any port when running anywhere else.
    // This is because some organizations block all ports other than 80 and 443. When deployed,
    // our nginx configuration will route all API requests to port 4000 transparently.
    if (isPlatformBrowser(this.platformId)) {
      this.API_SERVER_PORT = window.location.hostname === 'localhost' ? ':4000' : '';
      this.API_SOCKET_PORT = window.location.hostname === 'localhost' ? ':5001' : '';
      this.API_SOCKET_CRON_PORT = window.location.hostname === 'localhost' ? ':5001' : '';
      this.CARE_API_URL = window.location.hostname === 'portfolio.moneytor.in' ? 'https://api.moneytor.care' : 'https://uat-api.moneytor.care';
    } else {
      this.API_SERVER_PORT = '';
      this.API_SOCKET_PORT = '';
      this.API_SOCKET_CRON_PORT = '';
      this.CARE_API_URL = 'https://uat-api.moneytor.care';
    }
  }

  // Construct the url to be used for all API calls
  public getApiUrl(): string {
    if (isPlatformBrowser(this.platformId)) {
       return environment.api_url
    } else {
      return '';
    }
  }

  public getCareApiUrl(): string {
    return this.CARE_API_URL;
  }

  public checkAndGetV3Url(locationUrl: any, backendUrl: any): string {
    const isV3DashboardRoute =
      typeof locationUrl === 'string' &&
      /(^|\/)(dashboard-v3|management-dashboard)(\/|$)/.test(locationUrl);
    return isV3DashboardRoute ? backendUrl + '/v3' : backendUrl;
  }

  // commented as they are using the same port
  // Construct the url to be used for chat
  // public getChatUrl(): string {
  //   return `${window.location.protocol}//${window.location.hostname}${this.API_SOCKET_CRON_PORT}`;
  // }

  // Construct the url to be used for Incoming call
  public getIncomingUrl(): string {
    if (isPlatformBrowser(this.platformId)) {
      // return environment.socket_url
      return window.location.hostname === 'localhost' ? `${window.location.protocol}//${window.location.hostname}${this.API_SOCKET_PORT}` : environment.socket_url;
    } else {
      return environment.socket_url;
    }
  }

  // Construct the url to be used for cron actions via socket
  public getCronUrl(): string {
    if (isPlatformBrowser(this.platformId)) {
      // return environment.socket_url
      return window.location.hostname === 'localhost' ? `${window.location.protocol}//${window.location.hostname}${this.API_SOCKET_CRON_PORT}` : environment.socket_url;
    } else {
      return environment.socket_url;
    }
  }
}
